@if (visible() && (action().icon || action().tooltip)) {
  <!-- This comment to find the good icon for every single action -->
  @if (action().icon) {
    <sxw-svg-icon
      class="icon"
      width="16"
      height="16"
      [name]="action().icon"
      [fillColor]="action().fillColor ?? 'black'"
      [strokeColor]="action().strokeColor ?? 'var(--p-gray-400)'"
      [pTooltip]="action().tooltipMode ? (action().tooltip + '' | translate) : ''" />
  }
  @if (!action().tooltipMode) {
    <span>{{ action().tooltip + "" | translate }}</span>
  }
}
